import KarmaPage from '../../js/pages/KarmaPage';

export default KarmaPage;
